import { render, staticRenderFns } from "./Doubt.vue?vue&type=template&id=40066c06&scoped=true"
import script from "./Doubt.vue?vue&type=script&lang=js"
export * from "./Doubt.vue?vue&type=script&lang=js"
import style0 from "./Doubt.vue?vue&type=style&index=0&id=40066c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40066c06",
  null
  
)

export default component.exports